// extracted by mini-css-extract-plugin
export default {"sortSection":"SortSection_sortSection__Ugx9g"};